import { useSyncExternalStore } from "react";

/**
 * Whether this server is Preá Nuvem. There the customer talks to "Preá" and never sees which
 * models run it, so every model surface stays out of the interface. Preá Instalável brings its
 * own models and keeps them.
 */
let hosted = false;
const listeners = new Set<() => void>();

export function setHostedService(value: boolean | undefined) {
  const next = value === true;
  if (next === hosted) return;
  hosted = next;
  for (const listener of listeners) listener();
}

export function isHostedService(): boolean {
  return hosted;
}

export function useHostedService(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => hosted,
    () => false,
  );
}
